import { LOG_OUT } from './type';

export const logOutApplication = () => dispatch =>{
    dispatch({
     type : LOG_OUT,
     payload : {},
    });
};